import React, { useContext, useEffect, useState } from "react";

import styles from "./BannerPage.module.css";
import "./BannerPart3.css";
import axios from "axios";
import { baseUrl, dataContext, portal } from "../../App";
import { FaArrowRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import activityLogSubmission from "../../helper/activitylog";
import RotatingBox from "./RotatingBox";
import analyticEvent from "../../helper/gaEvent";
import SliderBanner from "./SliderBanner";
import logoImage from "./img/logo.png";
import playBtnImage from "./img/settings.png";
import banglaImage from "./img/bangla.png";
import englishImage from "./img/english.png";
import { BsFillInfoCircleFill } from "react-icons/bs";
import PromotionalBanner from "./PromotionalBanner/PromotionalBanner";
import PlayerStatusCard from "./PlayerStatusCard/PlayerStatusCard";
import PlayingHistory from "./PlayingHistory/PlayingHistory";
import DifficultySelectionModal from "../Modal/DifficultySelectionModal/DifficultySelectionModal";

const BannerPart3 = ({ props }) => {
  const navigate = useNavigate();
  const {
    token,
    setToken,
    playerData,
    setPlayerData,
    events,
    setEvents,
    extraData,
    setExtraData,
  } = useContext(dataContext);
  const {
    quizClickHandlerInLogin,
    setActiveBottom,
    setShowGameSelectionModal,
    setShowSpellingInfoModal,
    setShowLoginModal,
    handleSubscriptionById,
    gameBannerClickHandler,
    showDifficultyModal,
    setShowDifficultyModal
  } = props;

  useEffect(() => {
    let msisdn = null;

    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("home", msisdn);
    analyticEvent("home", "home-view");
  }, []);

    const handleDifficultySelect = (difficulty) => {
    // Store the selected difficulty in sessionStorage
    sessionStorage.setItem("memoryMatchDifficulty", difficulty);
    // Start the memory match game
    // quizClickHandlerInLogin(151, playerData);
    navigate(`/quiz/?eventId=${151}`)
  };

  function handleWordlyBannerClick(){
    if(!playerData?.id){setShowLoginModal(true);return;}
    if(!playerData?.isSubscribe){handleSubscriptionById(67);return;}
    setShowGameSelectionModal(true)
  }
  function handleMemoryMatchBannerClick(){
    if(!playerData?.id){setShowLoginModal(true);return;}
    if(!playerData?.isSubscribeMemoryMatch){handleSubscriptionById(151);return;}
    setShowDifficultyModal(true)
  }

  return (
    <>
      <div className={styles.bannerPageBody}>
        <div className={styles.backgroundWrapper}>
          <PlayerStatusCard data={playerData} />
          <div className={styles.gameCorner}>
            <div className={styles.gamesTitle}>
              <img
                src={require("./img/gamesIcon.png")}
                alt=""
                className={styles.gamesTitleImg}
              />
              <span>গেমস খেলে পুরস্কার জিতুন</span>
            </div>
            <div className={styles.gamesList}>
              <div
                className={styles.gameItem}
                onClick={() => gameBannerClickHandler('wordly', playerData)}
                style={{ backgroundImage: `url(${require("./img/bg1.png")})` }}
              >
                {/* <img src={require('./img/wordlyIcon.png')} alt="" className={styles.gameItemImg} />
                <div className={styles.gameItemTitle}>ওয়ার্ডলি</div>
                <button className={styles.playButton}>খেলুন <FaArrowRight /></button> */}
              </div>
              <div
                className={styles.gameItem}
                onClick={() => gameBannerClickHandler('spelling_bee', playerData)}
                style={{ backgroundImage: `url(${require("./img/bg2.png")})` }}
              ></div>
              <div
                className={styles.gameItem}
                onClick={() => gameBannerClickHandler('memory_match', playerData)}
                style={{ backgroundImage: `url(${require("./img/bg3_v2.png")})` }}
              ></div>
            </div>
          </div>
        </div>

        <PromotionalBanner bannerSrc={`/banners/promo/refer_v3.jpg`} handleClick={() => { setActiveBottom('referral'); activityLogSubmission('wordly_banner_1'); }} />
        <PromotionalBanner bannerSrc={`/banners/promo/quizard_v2.jpg`} handleClick={() => { window.open('https://bl.quizard.live/?qcid=115','_blank'); activityLogSubmission('quizard_from_wordly_banner'); }} />
        <PlayingHistory events={events} playerData={playerData} quizClickHandler={quizClickHandlerInLogin} />
      </div>

      <DifficultySelectionModal
        showModal={showDifficultyModal}
        setShowModal={setShowDifficultyModal}
        onDifficultySelect={handleDifficultySelect}
      />
    </>
  );
};

export default BannerPart3;
